import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import PasswordInput from "../../components/PasswordInput";
import Button from "../../components/Button";
import styles from "./styles.css";
import ScreenContainer from "../../components/ScreenContainer";
import Header from "../../components/Header";
import Note from "../../components/Note";
import CheckBox from "../../components/CheckBox";
import { useSessionCheck } from "../../hooks/useSessionCheck";
import { t } from "i18next";
import { Trans } from "react-i18next";

const Agreements = () => {
  useSessionCheck()
  const navigate = useNavigate();
  const [tosCheck, setTosCheck] = useState(false)
  const [ppCheck, setPpCheck] = useState(false)
  const [marketingCheck, setMarketingCheck] = useState(false)
  const isAllChecked = tosCheck && ppCheck && marketingCheck
  const isRequiredChecked = tosCheck && ppCheck

  function handleAllCheck() {
    setTosCheck(!isAllChecked)
    setPpCheck(!isAllChecked)
    setMarketingCheck(!isAllChecked)
  }

  const handleConfirm = () => {
    navigate('/plan_intro');
  };

  function trans(key) {
    return t("onb-web_termsandprivacypolicy_" + key)
  }

  return (
    <ScreenContainer>
      <Header />
      <div className={"scrollContainer"} style={{ minHeight: "calc(100dvh - 54px)" }}>

        <h1 className={"title title_m_24_medium"}>{trans(26)}</h1>
        <p className={"description body_15_regular mt-16"}>
          {trans(27)}
        </p>

        <div className={"form"}>
          <CheckBox
            label={trans(28)}
            style={style.checkrow}
            onPress={handleAllCheck}
            checked={isAllChecked}
          />
          <div style={style.divider} />
          <CheckBox
            label={<span><span style={style.asterisk}>*</span> {trans(29)}</span>}
            style={style.checkrow}
            onPress={() => setTosCheck(!tosCheck)}
            checked={tosCheck}
          />
          <label
            className="mt-16 body_15_regular"
            style={style.label}>
            <Trans i18nKey={"onb-web_termsandprivacypolicy_30"}>
              저는 Eyeary <a style={style.link} target="_blank" rel="noopener noreferrer" href="/tos">이용약관</a>을 읽고 동의합니다.
            </Trans>
          </label>
          <CheckBox
            className={"mt-24"}
            label={<span><span style={style.asterisk}>*</span> {trans(31)}</span>}
            style={style.checkrow}
            onPress={() => setPpCheck(!ppCheck)}
            checked={ppCheck}
          />
          <label
            className="mt-16 body_15_regular"
            style={style.label}>
            <Trans i18nKey={"onb-web_termsandprivacypolicy_32"}>
              저는 Eyeary <a style={style.link} target="_blank" rel="noopener noreferrer" href="/privacy_policy">개인정보처리방침</a>을 읽고 동의합니다.
            </Trans>
          </label>
          <CheckBox
            className={"mt-24"}
            label={trans(33)}
            style={style.checkrow}
            onPress={() => setMarketingCheck(!marketingCheck)}
            checked={marketingCheck}
          />
          <label
            className="mt-16 body_15_regular"
            style={style.label}>{trans(34)}</label>
        </div>

        <Button
          text={t('continue')}
          onClick={handleConfirm}
          disabled={!isRequiredChecked}
          primary={isRequiredChecked}
          className={(isRequiredChecked ? "primary-on-button" : "primary-off-button") + " primary-button-text"}

        />
      </div>
    </ScreenContainer>
  );
};

const style = {
  checkrow: {
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
  },
  divider: {
    backgroundColor: '#23292E',
    height: '1px',
    width: '100%',
    marginTop: 24,
    marginBottom: 24
  },
  asterisk: {
    color: '#FF0000'
  },
  label: {
    height: 44,
    color: "#D7DEE6"
  },
  link: {
    textDecoration: 'underline'
  }
}

export default Agreements;
